"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAY_MS = void 0;
exports.msToUtcDay = msToUtcDay;
exports.utcDayStartMs = utcDayStartMs;
exports.utcMidnightMs = utcMidnightMs;
exports.buildUtcDayList = buildUtcDayList;
exports.windowStartMs = windowStartMs;
exports.DAY_MS = 24 * 60 * 60 * 1000;
function msToUtcDay(ms) {
    return new Date(ms).toISOString().slice(0, 10);
}
function utcDayStartMs(day) {
    return Date.parse(`${day}T00:00:00.000Z`);
}
function utcMidnightMs(ms) {
    const d = new Date(ms);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}
function buildUtcDayList(nowMs, lookbackDays) {
    const todayStart = utcMidnightMs(nowMs);
    const days = [];
    for (let i = lookbackDays - 1; i >= 0; i -= 1) {
        days.push(msToUtcDay(todayStart - i * exports.DAY_MS));
    }
    return days;
}
function windowStartMs(nowMs, lookbackDays) {
    return utcMidnightMs(nowMs) - (lookbackDays - 1) * exports.DAY_MS;
}
//# sourceMappingURL=utc-day.js.map